import * as C from "../constants";

import { get_daily_sales, get_month_sum_sales, get_month_avg_sales,
    get_payment_types_share_in_sales, get_machines_addresses,
    get_daily_sales_count
} from "utils/http";
import { parseJSON } from "utils/misc";
import { logout } from "./auth";
import { history } from "../history";

export function getStatisticsDailySalesRequest() {
    return {
        type: C.GET_STATISTICS_DAILY_SALES_REQUEST
    }
}

export function getStatisticsDailySalesFailure() {
    return {
        type: C.GET_STATISTICS_DAILY_SALES_FAILURE
    }
}

export function getStatisticsDailySalesSuccess(data) {
    return {
        type: C.GET_STATISTICS_DAILY_SALES_SUCCESS,
        payload: data
    }
}

export function getStatisticsMonthSumSalesRequest() {
    return {
        type: C.GET_STATISTICS_MONTH_SUM_SALES_REQUEST
    }
}

export function getStatisticsMonthSumSalesFailure() {
    return {
        type: C.GET_STATISTICS_MONTH_SUM_SALES_FAILURE
    }
}

export function getStatisticsMonthSumSalesSuccess(data) {
    return {
        type: C.GET_STATISTICS_MONTH_SUM_SALES_SUCCESS,
        payload: data,
    }
}

export function getStatisticsMonthAverageSalesRequest() {
    return {
        type: C.GET_STATISTICS_MONTH_AVERAGE_SALES_REQUEST
    }
}

export function getStatisticsMonthAverageSalesFailure() {
    return {
        type: C.GET_STATISTICS_MONTH_AVERAGE_SALES_FAILURE
    }
}

export function getStatisticsMonthAverageSalesSuccess(data) {
    return {
        type: C.GET_STATISTICS_MONTH_AVERAGE_SALES_SUCCESS,
        payload: data,
    }
}

export function getStatisticsDailySales(token, year, month, type) {
    return function (dispatch) {
        dispatch(getStatisticsDailySalesRequest());
        get_daily_sales(token, year, month, type)
            .then(parseJSON).then(response => {
                dispatch(getStatisticsDailySalesSuccess(response))
        }).catch(error => {
            dispatch(getStatisticsDailySalesFailure());
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                history.replace("/login");
            }
        })
    }
}

export function getStatisticsPaymentTypesShareInSalesRequest() {
    return {
        type: C.GET_STATISTICS_PAYMENT_TYPES_SHARE_IN_SALES_REQUEST
    }
}

export function getStatisticsPaymentTypesShareInSalesFailure() {
    return {
        type: C.GET_STATISTICS_PAYMENT_TYPES_SHARE_IN_SALES_FAILURE
    }
}

export function getStatisticsPaymentTypesShareInSalesSuccess(data) {
    return {
        type: C.GET_STATISTICS_PAYMENT_TYPES_SHARE_IN_SALES_SUCCESS,
        payload: data,
    }
}

export function getStatisticsMachinesRequest() {
    return {
        type: C.GET_STATISTICS_MACHINES_REQUEST
    }
}

export function getStatisticsMachinesFailure() {
    return {
        type: C.GET_STATISTICS_MACHINES_FAILURE,
    }
}

export function getStatisticsMachinesSuccess(data) {
    return {
        type: C.GET_STATISTICS_MACHINES_SUCCESS,
        payload: data
    }
}

export function getStatisticsDailySalesCountRequest() {
    return {
        type: C.GET_STATISTICS_DAILY_SALES_COUNT_REQUEST,
    }
}

export function getStatisticsDailySalesCountFailure() {
    return {
        type: C.GET_STATISTICS_DAILY_SALES_COUNT_FAILURE,
    }
}

export function getStatisticsDailySalesCountSuccess(data) {
    return {
        type: C.GET_STATISTICS_DAILY_SALES_COUNT_SUCCESS,
        payload: data
    }
}

export function getStatisticsMonthSumSales(token, year, type) {
    return function (dispatch) {
        dispatch(getStatisticsMonthSumSalesRequest());
        get_month_sum_sales(token, year, type)
            .then(parseJSON).then(response => {
                dispatch(getStatisticsMonthSumSalesSuccess(response))
        }).catch(error => {
            dispatch(getStatisticsMonthSumSalesFailure());
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                history.replace("/login");
            }
        })
    }
}

export function getStatisticsMonthAverageSales(token, year, type) {
    return function (dispatch) {
        dispatch(getStatisticsMonthAverageSalesRequest());
        get_month_avg_sales(token, year, type)
            .then(parseJSON).then(response => {
            dispatch(getStatisticsMonthAverageSalesSuccess(response))
        }).catch(error => {
            dispatch(getStatisticsMonthAverageSalesFailure());
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                history.replace("/login");
            }
        })
    }
}

export function getStatisticsPaymentTypesShareInSales(token, machines, fromTime, toTime, type) {
    return function (dispatch) {
        dispatch(getStatisticsPaymentTypesShareInSalesRequest());
        get_payment_types_share_in_sales(token, machines, fromTime, toTime, type)
            .then(parseJSON).then(response => {
                dispatch(getStatisticsPaymentTypesShareInSalesSuccess(response))
        }).catch(error => {
            dispatch(getStatisticsPaymentTypesShareInSalesFailure());
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                history.replace("/login");
            }
        })
    }
}

export function getStatisticsMachines(token) {
    return function (dispatch) {
        dispatch(getStatisticsMachinesRequest());
        get_machines_addresses(token)
            .then(parseJSON).then(response => {
                dispatch(getStatisticsMachinesSuccess(response))
        }).catch(error => {
            dispatch((getStatisticsMachinesFailure()));
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                history.replace("/login");
            }
        })
    }
}

export function getStatisticsDailySalesCount(token, year, month) {
    return function (dispatch) {
        dispatch(getStatisticsDailySalesCountRequest());
        return get_daily_sales_count(token, year, month)
            .then(parseJSON).then(response => {
                dispatch(getStatisticsDailySalesCountSuccess(response));
            }).catch(error => {
                dispatch((getStatisticsDailySalesCountFailure()));
                if (error.response && error.response.status === 401) {
                    dispatch(logout());
                    history.replace("/login");
                }
            })
    }
}


// WEBPACK FOOTER //
// ./src/actions/statistics.js